import clsx from 'clsx';
import React from 'react';
export const BigInputComponent = props => {
  const {
    children,
    className = 'big-input',
    focusedClassName = 'big-input-focused',
    errorClassName = 'big-input-error',
    label,
    error,
    focused,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: clsx(className, {
      [focusedClassName]: focused,
      [errorClassName]: error
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, children)));
};